import {getURISegment} from "@Utils/url.util.ts";
import {getSupportedVisibilityChangeEvent} from "@Utils/browser.util.ts";

/**
 * Listeners related to the Storage
 *
 * @param {object} opt The grapesjs config object
 */
export default (opt = {}) => {
    let editor = opt.editor,
        assets = editor.AssetManager,
        assetsConfig = assets.getConfig();

    assetsConfig.uploadFile = function (e) {
        let files = e.dataTransfer ? e.dataTransfer.files : e.target.files,
            formData;

        if (files.length > 0) {
            files.forEach((file) => {
                formData = new FormData();
                formData.append('Filedata', file);

                PMW.write(PMW.util.site_url('posterimage/emailUpload'), formData)
                    .done(function (result) {
                        let image = result.data; // <- should be an array of uploaded images
                        editor.AssetManager.add(image);

                        editor.runCommand(window.PMW.emails.commands.UPDATE_LOADING_IMG_WITH_RESPONSE, {
                            'identifier': file[window.PMW.emails.props.DROP_IDENTIFIER],
                            'imgResponse': image
                        });
                    })
            });
        }
    };

    editor.on('asset:upload:response', (response) => {
        let result = JSON.parse(response);
        editor.AssetManager.add(result.data);
    });

    document.addEventListener(window.PMW.emails.CUSTOM_EVENT_STORAGE_END, async (data) => {
        if (window.PMW.emails.SAVE_QUEUED) {
            window.PMW.emails.SAVE_QUEUED = false;
            await editor.store({});
        }
    });

    attachListenersToSaveToDB(editor, window.PMW.emails.commands.SAVE_TO_DB);
    $(document).ready(appendInhouseDesignerURI);

    function appendInhouseDesignerURI() {
        if (getURISegment(3)) {
            let newEmailCta = $('.js-new-email-cta');
            newEmailCta.attr('href', newEmailCta.attr('href') + '//1');
        }
    }
}

/**
 * @param {grapesjs.Editor} editor
 * @param {string} saveToDbCommand
 */
export function attachListenersToSaveToDB(editor, saveToDbCommand) {
    const [visibilityChange, visibilityHidden] = getSupportedVisibilityChangeEvent();
    document.addEventListener(visibilityChange, function () {
        if (!document[visibilityHidden]) {
            return;
        }
        onNavigateAway(editor, saveToDbCommand);
    });
    // running on beforeUnload as a backup for browsers that don't trigger visibilityChange on refresh/window-close
    window.addEventListener('beforeunload', _ => onNavigateAway(editor, saveToDbCommand));
}

/**
 * trigger endpoint to save cached payload to DB
 * @param {grapesjs.Editor} editor
 * @param {String} saveToDbCommand
 */
function onNavigateAway(editor, saveToDbCommand) {
    editor.runCommand(saveToDbCommand, {});
}
